(function () {
var w = window, d = document, html = d.documentElement;
var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!reduce && !(w.Shopify && w.Shopify.designMode)) html.classList.add('ax-motion');
function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
ready(function () {
var NAV = 52, motion = html.classList.contains('ax-motion');
var nav = d.querySelector('[data-ax-nav]');
var reveals = $$('[data-ax-reveal]');
if (motion && 'IntersectionObserver' in w) {
var io = new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
}, { rootMargin: '0px 0px -10% 0px' });
reveals.forEach(function (el) { io.observe(el); });
} else reveals.forEach(function (el) { el.classList.add('is-in'); });
if (motion) $$('[data-ax-words]').forEach(function (el) {
var frag = d.createDocumentFragment();
Array.prototype.slice.call(el.childNodes).forEach(function (n) {
var hl = n.nodeType === 1;
(n.textContent || '').split(' ').forEach(function (part) {
part = part.trim();
if (!part) return;
var s = d.createElement('span'); s.className = 'w' + (hl ? ' hl' : ''); s.textContent = part; frag.appendChild(s);
frag.appendChild(d.createTextNode(' '));
});
});
el.textContent = ''; el.appendChild(frag);
});
var scenes = $$('[data-ax-scene]').map(function (el) {
return {
el: el, mode: el.getAttribute('data-ax-scene'),
items: $$('[data-ax-range]', el).map(function (x) {
var r = x.getAttribute('data-ax-range').split(',');
return { el: x, a: +r[0], b: +r[1], ease: x.hasAttribute('data-ax-ease'), draw: x.hasAttribute('data-ax-draw') ? $$('path', x) : null, q: -1 };
}),
words: $$('[data-ax-words] .w', el)
};
});
var pars = $$('[data-ax-par]');
function progress(el, mode) {
var r = el.getBoundingClientRect(), vh = w.innerHeight;
if (mode === 'out') return clamp((NAV - r.top) / Math.max(1, r.height));
var span = r.height - (vh - NAV);
if (span <= 0) return r.top < NAV ? 1 : 0;
return clamp((NAV - r.top) / span);
}
var queued = false;
function frame() {
queued = false;
if (nav) nav.classList.toggle('is-scrolled', (w.pageYOffset || 0) > 4);
if (!motion) return;
var vh = w.innerHeight;
scenes.forEach(function (sc) {
var box = sc.el.getBoundingClientRect();
if (box.bottom < -60 || box.top > vh + 60) return;
var p = progress(sc.el, sc.mode);
sc.el.style.setProperty('--p', p.toFixed(4));
sc.items.forEach(function (it) {
var q = clamp((p - it.a) / (it.b - it.a));
if (it.ease) q = 1 - Math.pow(1 - q, 3);
q = Math.round(q * 1000) / 1000;
if (q === it.q) return;
it.q = q;
it.el.style.setProperty('--q', q);
if (it.draw) it.draw.forEach(function (pa) { pa.style.strokeDashoffset = String(100 - q * 100); });
});
var n = sc.words.length;
if (n) sc.words.forEach(function (wd, i) { wd.classList.toggle('on', p >= 0.08 + (i / n) * 0.72); });
});
pars.forEach(function (el) {
var r = el.getBoundingClientRect();
if (r.bottom < -100 || r.top > vh + 100) return;
var f = parseFloat(el.getAttribute('data-ax-par')) || 0.08;
el.style.setProperty('--par', ((r.top + r.height / 2 - vh / 2) * -f).toFixed(1) + 'px');
});
}
function queue() { if (!queued) { queued = true; w.requestAnimationFrame(frame); } }
w.addEventListener('scroll', queue, { passive: true });
w.addEventListener('resize', queue);
w.addEventListener('load', queue);
frame();
$$('[data-ax-colours]').forEach(function (box) {
var imgs = $$('[data-ax-img]', box), btns = $$('[data-ax-sw]', box), name = box.querySelector('[data-ax-name]');
var i = 0, user = false, timer = null;
function set(k) {
i = k;
imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === k); });
btns.forEach(function (b, j) { b.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
if (name && btns[k]) name.textContent = btns[k].getAttribute('data-name');
}
btns.forEach(function (b, j) { b.addEventListener('click', function () { user = true; clearInterval(timer); set(j); }); });
set(0);
if (motion && btns.length > 1 && 'IntersectionObserver' in w) {
new IntersectionObserver(function (es) {
es.forEach(function (e) {
clearInterval(timer);
if (e.isIntersecting && !user) timer = setInterval(function () { set((i + 1) % btns.length); }, 2400);
});
}, { threshold: 0.45 }).observe(box);
}
});
$$('[data-ax-buy]').forEach(function (box) {
var input = box.querySelector('[data-ax-variant]'), price = box.querySelector('[data-ax-price]');
var cname = box.querySelector('[data-ax-cname]'), imgs = $$('[data-ax-bimg]', box), btns = $$('[data-ax-bsw]', box);
function set(b) {
btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
var id = b.getAttribute('data-id');
if (input) input.value = id;
if (price) price.textContent = b.getAttribute('data-price');
if (cname) cname.textContent = b.getAttribute('data-name');
imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-ax-bimg') === id); });
if (box.hasAttribute('data-ax-url') && w.history && w.history.replaceState) {
try { var u = new URL(w.location.href); u.searchParams.set('variant', id); w.history.replaceState({}, '', u.toString()); } catch (e) {}
}
}
btns.forEach(function (b) { b.addEventListener('click', function () { set(b); }); });
});
var toast = d.getElementById('ax-toast');
if (toast) {
var KEY = 'aerloWelcome', DAY = 864e5;
var read = function () { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
var write = function (v) { try { localStorage.setItem(KEY, v); } catch (e) {} };
var open = function () { toast.hidden = false; w.requestAnimationFrame(function () { w.requestAnimationFrame(function () { toast.classList.add('is-open'); }); }); };
var close = function () { toast.classList.remove('is-open'); if (read() !== 'done') write(String(Date.now())); setTimeout(function () { toast.hidden = true; }, 700); };
$$('[data-ax-toast-close]', toast).forEach(function (b) { b.addEventListener('click', close); });
if (toast.querySelector('[data-ax-ok]')) { write('done'); open(); }
else if (toast.hasAttribute('data-armed')) {
var st = read();
if (!(st === 'done' || (st && Date.now() - Number(st) < 14 * DAY))) {
var delay = Math.max(5, parseInt(toast.getAttribute('data-delay'), 10) || 12) * 1000;
setTimeout(function () {
var cp = w.Shopify && w.Shopify.customerPrivacy, pending = false;
try { pending = !!(cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner()); } catch (e) {}
if (!pending) { open(); return; }
d.addEventListener('visitorConsentCollected', function onC() { d.removeEventListener('visitorConsentCollected', onC); setTimeout(open, 3000); });
}, delay);
}
}
}
d.addEventListener('click', function (e) {
var l = e.target.closest ? e.target.closest('[data-cookie-prefs]') : null;
if (!l || !w.privacyBanner || typeof w.privacyBanner.showPreferences !== 'function') return;
e.preventDefault(); w.privacyBanner.showPreferences();
});
});
})();